/**
 * 350ms cross-fade for theme switches (spec section 3).
 * Injects a one-time style tag and briefly arms transitions on the whole tree.
 * Respects prefers-reduced-motion (instant swap).
 */

const STYLE_ID = "softlavka-theme-fade-style";
const FADE_CLASS = "softlavka-theme-fade";
const FADE_MS = 350;

const FADE_CSS = `
html.${FADE_CLASS}, html.${FADE_CLASS} * {
  transition: background-color ${FADE_MS}ms ease, color ${FADE_MS}ms ease, border-color ${FADE_MS}ms ease, fill ${FADE_MS}ms ease !important;
}
`;

export function withThemeTransition(apply: () => void): void {
  if (
    typeof window === "undefined" ||
    typeof document === "undefined" ||
    (typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches)
  ) {
    apply();
    return;
  }
  if (!document.getElementById(STYLE_ID)) {
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = FADE_CSS;
    document.head.appendChild(style);
  }
  document.documentElement.classList.add(FADE_CLASS);
  apply();
  window.setTimeout(() => {
    document.documentElement.classList.remove(FADE_CLASS);
  }, FADE_MS + 50);
}
